/**
 * ------------------------------------------------------
 * ALTENS — NEWSLETTER RECAPTCHA V3
 * ------------------------------------------------------
 *
 * Compatible avec :
 * - Newsletter ACF
 * - Newsletter home.php
 *
 * Action Google : newsletter
 */

const initNewsletterRecaptcha = () => {
    const forms = document.querySelectorAll("[data-altens-newsletter]");

    if (!forms.length) {
        return;
    }

    forms.forEach((form) => {
        // Évite d'ajouter plusieurs écouteurs
        if (form.dataset.recaptchaInitialized === "true") {
            return;
        }

        form.dataset.recaptchaInitialized = "true";

        let isSubmitting = false;

        form.addEventListener("submit", async (event) => {
            event.preventDefault();

            if (isSubmitting) {
                return;
            }

            // Validation native
            if (!form.reportValidity()) {
                return;
            }

            // Clé publique injectée par WordPress
            const siteKey = window.altensRecaptcha?.siteKey;

            if (!siteKey || !window.grecaptcha || typeof window.grecaptcha.execute !== "function") {
                console.error("Altens Newsletter : Google reCAPTCHA indisponible.");

                alert("La vérification de sécurité est indisponible. Veuillez réessayer.");

                return;
            }

            const submitButton = form.querySelector('[type="submit"]');

            isSubmitting = true;

            if (submitButton) {
                submitButton.disabled = true;
                submitButton.setAttribute("aria-busy", "true");
            }

            try {
                // Attendre l'initialisation de Google
                await new Promise((resolve) => {
                    window.grecaptcha.ready(resolve);
                });

                // Générer le jeton reCAPTCHA v3
                const token = await window.grecaptcha.execute(siteKey, {
                    action: "newsletter",
                });

                if (!token) {
                    throw new Error("Jeton reCAPTCHA non généré.");
                }

                // Injecter le jeton dans le formulaire
                const tokenInput = form.querySelector('[name="g-recaptcha-response"]');

                if (!tokenInput) {
                    throw new Error("Champ reCAPTCHA introuvable.");
                }

                tokenInput.value = token;

                // Soumission native vers admin-post.php
                HTMLFormElement.prototype.submit.call(form);
            } catch (error) {
                console.error("Altens Newsletter :", error);

                alert("La vérification de sécurité a échoué. Veuillez réessayer.");

                isSubmitting = false;

                if (submitButton) {
                    submitButton.disabled = false;
                    submitButton.removeAttribute("aria-busy");
                }
            }
        });
    });
};

export default initNewsletterRecaptcha;
